const previousMouse = {
    x: null,
    y: null,
};
const listenMouseMove = (event, callback) => {
    /* Detect mouse move with a threshold of 2px to prevent
       mouseMove being triggered by Safari when pressing a key */
    requestAnimationFrame(() => {
        const currentMouseX = event.clientX;
        const currentMouseY = event.clientY;
        if (previousMouse.x !== null && previousMouse.y !== null) {
            const deltaX = Math.abs(currentMouseX - previousMouse.x);
            const deltaY = Math.abs(currentMouseY - previousMouse.y);
            if (deltaX >= 2 || deltaY >= 2) {
                callback();
            }
        }
        previousMouse.x = currentMouseX;
        previousMouse.y = currentMouseY;
    });
};

export { listenMouseMove as l };
